export const INTAKE_URL = 'https://start.alfameds.com/start-online-visit/glp1-intake';

const REFERRAL_KEYS = ['referral-campaign', 'referral-source', 'promo'];
const STORAGE_KEY = 'alfa_referral';
const INTAKE_HOST = 'start.alfameds.com';
const INTAKE_PATH_PREFIX = '/start-online-visit/';

let memoryGroup = null;

const readStorage = () => {
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const writeStorage = (group) => {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(group));
  } catch {
    /* storage unavailable: memoryGroup still holds the current page's values */
  }
};

const groupFromSearch = (search) => {
  const params = new URLSearchParams(search);
  const group = {};
  REFERRAL_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) group[k] = v;
  });
  return Object.keys(group).length ? group : null;
};

// Any incoming referral parameter replaces the whole stored group (no mixing).
export const captureReferral = (search = window.location.search) => {
  const incoming = groupFromSearch(search);
  if (incoming) {
    memoryGroup = incoming;
    writeStorage(incoming);
  }
  return getReferral();
};

export const getReferral = () => memoryGroup || readStorage() || groupFromSearch(window.location.search);

export const isIntakeUrl = (href) => {
  try {
    const u = new URL(href, window.location.href);
    return u.protocol === 'https:' && u.hostname === INTAKE_HOST && u.pathname.startsWith(INTAKE_PATH_PREFIX);
  } catch {
    return false;
  }
};

export const withReferral = (href) => {
  if (!isIntakeUrl(href)) return href;
  const group = getReferral();
  if (!group) return href;
  const u = new URL(href, window.location.href);
  REFERRAL_KEYS.forEach((k) => {
    if (group[k]) u.searchParams.set(k, group[k]);
  });
  return u.toString();
};

export const intakeHref = (href = INTAKE_URL) => withReferral(href);

// Safety net: refresh intake link hrefs right before any activation (click, middle-click, keyboard, context menu).
export const installIntakeLinkForwarding = () => {
  const refresh = (e) => {
    const a = e.target instanceof Element ? e.target.closest('a[href]') : null;
    if (!a || !isIntakeUrl(a.href)) return;
    const next = withReferral(a.href);
    if (next !== a.href) a.setAttribute('href', next);
  };
  ['mousedown', 'click', 'auxclick', 'keydown', 'contextmenu', 'touchstart'].forEach((type) =>
    document.addEventListener(type, refresh, true)
  );
  const trackLead = (e) => {
    if (e.type === 'auxclick' && e.button !== 1) return;
    const a = e.target instanceof Element ? e.target.closest('a[href]') : null;
    if (a && isIntakeUrl(a.href) && typeof window.fbq === 'function') window.fbq('track', 'Lead');
  };
  ['click', 'auxclick'].forEach((type) => document.addEventListener(type, trackLead, true));
};
